import { SearchBarManageTrainingCode } from "../helper/SearchBars";
import {useState, useEffect, useContext,useRef} from 'react';
import axios from 'axios';
import moment from 'moment';

import styles from '../styles';
import withStyles from '@mui/styles/withStyles';
import PageHeader from '../helper/PageHeader';
import Loading from '../helper/Loading';
import SimpleTable from '../helper/SimpleTable';
import { EnterNewUsedByDate } from '../helper/Dialogs';
import { authContext } from '../../context/AuthContext';

const tableCells = [
    { id: 'serialNumber', label: 'Training Code', centered: false },
    { id: 'type', label: 'Training Type', centered: false },
    { id: 'usedBy', label: 'Used By', centered: false },
];

function AdminManageTrainingCode(props){

    const { classes } = props;
    const context = useContext(authContext)

    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [valid, setValid] = useState(false)
    const [searchData, setSearchData] = useState({
        languages: '',
        trainingType: '',
        trainingCode:  '',
    })

    const [newusedByDetails, setNewUsedByDetails] = useState({
        ID:'',
        serialNumber: '',
        trainingType: '',
        usedBy: ''
    });

    const mounted = useRef(true)

    useEffect(() => {
        // on unmount
        return () => mounted.current = false
    }, [])

    const handleSearch = (search) => {
        setSearchData(search)
        onSearch(search)
    }

    const onSearch = (search) => {
        
        if(search===null) search = searchData // if this is called from delete, then delete uses the main state (searchData)
        setLoading(true)
        console.log('here is the updated data', searchData );
        console.log('here is the updated data 2', search );
        setSearchData(search)
        axios.get('/api/trainingCode/search', {
            params: {

                trainingType: search.trainingType ? search.trainingType.value : null,
                trainingCode: search.trainingCode? search.trainingCode : null,

            }
        }).then((res) => {
            console.log('response is', res.data)
            console.log('resp', res)
            
            setData(res.data)
            console.log('data after updating', data);
            setLoading(false)
        })
    }


    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };

    const onRefundUpdate = async (id) => {
        const creditLog = data.trainingCode.find(e => e.id === id)
        console.log(creditLog);
        setNewUsedByDetails( prev => {return {...prev, ID: creditLog.id, usedBy: creditLog.usedBy, serialNumber:creditLog.serialNumber, trainingType:creditLog.type  }})
        console.log(newusedByDetails);
        handleClickOpen();
        // if(creditLog.action === "Refund Credit"){
           
        // } 

    }

    const actionButtons = [
        { icon: "edit", label: "Edit", action: onRefundUpdate, delete: false },
    ];

    const handleDateProcessed = (event) => {
        event.persist()
        let date = moment(event.target.value);
        console.log('date validity', date.isValid() )
        setValid(date.isValid());
        setNewUsedByDetails( prev => {return {...prev, usedBy: event.target.value}})
        console.log('date processed', setNewUsedByDetails.usedBy);
    }

    const handleRefundClick = async () => {
        
        console.log('data to be sent to server', newusedByDetails );

        let token = context.accessToken;

        let data = {
            usedBy: newusedByDetails.usedBy

        }

        console.log(data);

    //     const res = await axios('/api/trainingCode/' + newusedByDetails.ID , {
    //         method: 'POST',
    //         data: JSON.stringify(data.usedBy),
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Authorization': token
    //         }
    //     })
    //    // reloads user credit log
        let res = await axios.post('/api/trainingCode/'+ newusedByDetails.ID ,{
            usedBy : newusedByDetails.usedBy
        },{
            headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
        } )
       console.log('res', res);
       console.log("closing dialog");
       handleClose()
        // getData()
        axios.get('/api/trainingCode/search', {
            params: {

                trainingType: searchData.trainingType ? searchData.trainingType.value : null,
                trainingCode: searchData.trainingCode? searchData.trainingCode : null,

            }
        }).then((res) => {
            console.log('response is', res.data)
            console.log('resp', res)
            
            setData(res.data)
            console.log('data after updating', data);
            setLoading(false)
        })


        
    }

    return (
        <>
        <PageHeader
                title={"Manage Training Code"}
            />

        <SearchBarManageTrainingCode classes={classes} onSearch={handleSearch} />
        {loading === true ? <Loading /> :
                data === null ? <></> :
                data.trainingCode.length===0 ? <h3>No data found for this search</h3> :
                <div>
                    <h3>{data.trainingCode.length} records found for this search</h3> 
                    <SimpleTable
                        data={data.trainingCode}
                        cellKey={"id"}
                        tableCells={tableCells}
                        actionButtons={actionButtons}
                        actions={true}
                    />
                    <EnterNewUsedByDate 
                        open={open}
                        serialNumber={newusedByDetails.serialNumber}
                        trainingType={newusedByDetails.trainingType}
                        usedBy={newusedByDetails.usedBy}
                        onClose={handleClose}
                        onDateChange = {handleDateProcessed}
                        onRefundClick = {handleRefundClick}
                        valid = {valid}
                        />
                </div>
            }
        </>
    );
}

export default withStyles(styles, { withTheme: true })(AdminManageTrainingCode);